import { LEVELS, INDICATOR_TYPES, EVALUATION_MODES } from './types'

export const CORE_REQUIRED_INDICATOR_IDS = [2, 3, 6, 12, 15, 22, 23, 26]

export const indicators = [
  {
    id: 1,
    level1: '创新环境',
    level2: '创新基础',
    name: '企业上一年度年末职工情况',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '企业在报告年度内平均拥有的从业人员数。引领级强调行业相对规模。',
    fields: [
      { key: 'totalEmployees', label: '上一年度年末职工人数', unit: '人', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'required',
        rules: [{ field: 'totalEmployees', operator: '>=', value: 50 }]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        rules: [{ field: 'totalEmployees', operator: '>=', value: 100 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ field: 'totalEmployees', operator: '>=', value: 300 }]
      }
    }
  },
  {
    id: 2,
    level1: '创新环境',
    level2: '创新基础',
    name: '研发人员配置情况',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '上一年度内企业内部直接参加研发项目人员，以及研发活动的管理和直接服务的人员。',
    fields: [
      { key: 'rdStaffCount', label: '专职研发人员数量', unit: '人', type: 'number' },
      { key: 'rdStaffRatio', label: '研发人员占比', unit: '%', type: 'number' },
      {
        key: 'stemRatio',
        label: 'STEM专业研发人员占比',
        unit: '%',
        type: 'number',
        help: '“STEM专业研发人员占比”指报告年度末，企业研发人员中，最高学历所学专业属于自然科学、工程技术、数学等STEM领域的人员数量占研发人员总数的百分比。'
      },
      { key: 'masterRatio', label: '硕士及以上占比', unit: '%', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              {
                logic: 'OR',
                conditions: [
                  { field: 'rdStaffCount', operator: '>=', value: 20 },
                  { field: 'rdStaffRatio', operator: '>=', value: 40 }
                ]
              },
              { field: 'stemRatio', operator: '>=', value: 50 }
            ]
          }
        ]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        isCoreRequired: true,
        rules: [
          {
            logic: 'AND',
            conditions: [
              { field: 'rdStaffCount', operator: '>=', value: 50 },
              { field: 'rdStaffRatio', operator: '>=', value: 15 },
              { field: 'masterRatio', operator: '>=', value: 40 },
              { field: 'stemRatio', operator: '>=', value: 60 }
            ]
          }
        ]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              {
                logic: 'OR',
                conditions: [
                  { field: 'rdStaffCount', operator: '>=', value: 200 },
                  { field: 'rdStaffRatio', operator: '>=', value: 25 }
                ]
              },
              { field: 'stemRatio', operator: '>=', value: 60 }
            ]
          }
        ]
      }
    }
  },
  {
    id: 3,
    level1: '创新环境',
    level2: '创新基础',
    name: '企业年度研发项目总量',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '企业上一年度内立项并开展研发的研究开发项目',
    fields: [
      { key: 'rdProjectCount', label: '研发项目数量', unit: '项', type: 'number' },
      { key: 'crossYearProjectCount', label: '跨年度战略性研发项目数量', unit: '项', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'required',
        rules: [{ field: 'rdProjectCount', operator: '>=', value: 2 }]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        isCoreRequired: true,
        rules: [{ field: 'rdProjectCount', operator: '>=', value: 5 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              { field: 'rdProjectCount', operator: '>=', value: 10 },
              { field: 'crossYearProjectCount', operator: '>=', value: 2 }
            ]
          }
        ]
      }
    }
  },
  {
    id: 4,
    level1: '创新环境',
    level2: '创新基础',
    name: '企业家近三年未来产业和新兴产业项目的投入占比',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '近三年对未来产业的研发投入占比',
    fields: [
      { key: 'emergingIndustryRatio', label: '近三年未来产业和新兴产业项目投入占比', unit: '%', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ field: 'emergingIndustryRatio', operator: '>=', value: 20 }]
      }
    }
  },
  {
    id: 5,
    level1: '创新环境',
    level2: '创新基础',
    name: '员工创新提案参与度与采纳率',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '企业建议员工创新提案管理体系',
    fields: [
      { key: 'proposalParticipationRate', label: '年度参与率', unit: '%', type: 'number' },
      { key: 'proposalAdoptionRate', label: '采纳率', unit: '%', type: 'number' },
      { key: 'majorBenefitCases', label: '产生重大经济效益案例数', unit: '个', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              { field: 'proposalParticipationRate', operator: '>=', value: 40 },
              { field: 'proposalAdoptionRate', operator: '>=', value: 10 },
              { field: 'majorBenefitCases', operator: '>=', value: 2 }
            ]
          }
        ]
      }
    }
  },
  {
    id: 6,
    level1: '创新环境',
    level2: '创新战略',
    name: '战略技术趋势制定',
    type: INDICATOR_TYPES.MANUAL_REVIEW,
    evaluationMode: EVALUATION_MODES.MANUAL,
    description: '评估企业对技术发展趋势的预判能力',
    fields: [
      { key: 'description', label: '企业情况说明（由审核人员结合材料核验）', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        isCoreRequired: true,
        evaluationMode: EVALUATION_MODES.MANUAL
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.MANUAL,
        ruleReviewRequired: true,
        note: '标准中达标级与引领级描述相同'
      }
    }
  },
  {
    id: 7,
    level1: '创新环境',
    level2: '创新战略',
    name: '重大科技攻关项目与自身匹配度',
    type: INDICATOR_TYPES.MANUAL_REVIEW,
    evaluationMode: EVALUATION_MODES.MANUAL,
    description: '评估企业科技攻关项目选题与自身短板解决的匹配度',
    fields: [
      { key: 'description', label: '企业情况说明（由审核人员结合材料核验）', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.MANUAL
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.MANUAL,
        ruleReviewRequired: true,
        note: '标准中达标级与引领级描述相同'
      }
    }
  },
  {
    id: 8,
    level1: '创新环境',
    level2: '创新战略',
    name: '重大科技攻关成效',
    type: INDICATOR_TYPES.MANUAL_REVIEW,
    evaluationMode: EVALUATION_MODES.MANUAL,
    description: '截止报告年度末企业在科技攻关项目既定指标实际达成情况',
    fields: [
      { key: 'description', label: '企业情况说明（由审核人员结合材料核验）', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.MANUAL
      }
    }
  },
  {
    id: 9,
    level1: '创新环境',
    level2: '创新战略',
    name: '重大科技攻关成果转化效率',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '成果从完成到规模化商业应用的周期与行业平均周期对比',
    fields: [
      { key: 'enterpriseConversionCycle', label: '企业成果转化周期', unit: '个月', type: 'number', min: 0.01 },
      { key: 'industryAverageConversionCycle', label: '行业平均转化周期', unit: '个月', type: 'number', min: 0.01 },
      { key: 'conversionShorteningRate', label: '较行业平均周期缩短比例（系统计算）', unit: '%', type: 'calculated', formula: 'reductionRate', fields: ['enterpriseConversionCycle', 'industryAverageConversionCycle'] },
      { key: 'description', label: '成果完成、规模化应用及行业对标口径说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ field: 'conversionShorteningRate', operator: '>=', value: 50 }],
        ruleReviewRequired: true,
        note: '需结合成果完成时间、规模化商业应用时间和行业平均周期来源核验'
      }
    }
  },
  {
    id: 10,
    level1: '创新环境',
    level2: '创新战略',
    name: '创新技术迭代周期',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '对比企业创新项目实际周期与历史周期，并说明创新管理改进措施',
    fields: [
      { key: 'historicalIterationCycle', label: '历史平均迭代周期', unit: '天', type: 'number', min: 0.01 },
      { key: 'actualIterationCycle', label: '当前实际迭代周期', unit: '天', type: 'number', min: 0.01 },
      { key: 'iterationOptimizationRate', label: '周期优化比例（系统计算）', unit: '%', type: 'calculated', formula: 'reductionRate', fields: ['actualIterationCycle', 'historicalIterationCycle'] },
      { key: 'description', label: '周期优化措施及创新管理改进说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ field: 'actualIterationCycle', operator: '<', compareField: 'historicalIterationCycle' }],
        ruleReviewRequired: true,
        note: '标准中达标级与引领级描述相同'
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ field: 'actualIterationCycle', operator: '<', compareField: 'historicalIterationCycle' }],
        ruleReviewRequired: true,
        note: '标准中达标级与引领级描述相同'
      }
    }
  },
  {
    id: 11,
    level1: '创新环境',
    level2: '创新战略',
    name: '创新项目成功率',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '投资≥500万的重大创新项目成功率及行业对比情况',
    fields: [
      { key: 'majorProjectSuccessRate', label: '重大创新项目成功率', unit: '%', type: 'number' },
      { key: 'industryAverageSuccessRate', label: '行业平均成功率', unit: '%', type: 'number' },
      { key: 'description', label: '重大项目及行业平均数据来源说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ logic: 'AND', conditions: [
          { field: 'majorProjectSuccessRate', operator: '>=', value: 70 },
          { field: 'majorProjectSuccessRate', operator: '>', compareField: 'industryAverageSuccessRate' }
        ] }],
        ruleReviewRequired: true,
        note: '“显著高于”的程度及行业平均数据来源需人工核验'
      }
    }
  },
  {
    id: 12,
    level1: '创新投入',
    level2: '研发投入',
    name: '研发经费支出',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '上一年度企业研发活动的经费支出合计',
    fields: [
      { key: 'rdExpenditure', label: '研发经费支出', unit: '万元', type: 'number' },
      { key: 'rdExpenditureRatio', label: '研发经费占主营业务收入比例', unit: '%', type: 'number' },
      { key: 'revenue', label: '主营业务收入', unit: '万元', type: 'number' },
      { key: 'isSpecializedAI', label: '是否为专精特新AI企业', type: 'radio', options: ['是', '否'] },
      { key: 'revenueLevel', label: '营收规模', type: 'radio', options: ['<1.5亿', '1.5亿-2亿', '2亿-10亿', '≥10亿'] }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              { field: 'rdExpenditure', operator: '>=', value: 600 },
              { field: 'rdExpenditureRatio', operator: '>=', value: 8 }
            ]
          }
        ]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        isCoreRequired: true,
        rules: [
          {
            logic: 'OR',
            conditions: [
              {
                logic: 'AND',
                conditions: [
                  { field: 'rdExpenditure', operator: '>=', value: 2000 },
                  { field: 'rdExpenditure', operator: '<=', value: 5000 },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 8 }
                ]
              },
              { field: 'rdExpenditure', operator: '>=', value: 8000 },
              {
                logic: 'AND',
                conditions: [
                  { field: 'isSpecializedAI', operator: '==', value: '是' },
                  { field: 'revenue', operator: '<', value: 15000 },
                  { field: 'rdExpenditure', operator: '>=', value: 1200 },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 15 }
                ]
              },
              {
                logic: 'AND',
                conditions: [
                  { field: 'revenueLevel', operator: '==', value: '≥10亿' },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 3 }
                ]
              }
            ]
          }
        ]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'OR',
            conditions: [
              {
                logic: 'AND',
                conditions: [
                  { field: 'rdExpenditure', operator: '>=', value: 10000 },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 5 }
                ]
              },
              {
                logic: 'AND',
                conditions: [
                  { field: 'isSpecializedAI', operator: '==', value: '是' },
                  { field: 'revenue', operator: '<', value: 20000 },
                  { field: 'rdExpenditure', operator: '>=', value: 1800 },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 10 }
                ]
              },
              {
                logic: 'AND',
                conditions: [
                  { field: 'revenueLevel', operator: '==', value: '≥10亿' },
                  { field: 'rdExpenditureRatio', operator: '>=', value: 3 }
                ]
              }
            ]
          }
        ]
      }
    }
  },
  {
    id: 13,
    level1: '创新投入',
    level2: '研发投入',
    name: '研发经费投入动态领先度',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '近三年复合增长率与地区平均水平对比，并核验关键领域定向增投或行业标杆领先情况',
    fields: [
      { key: 'threeYearCagr', label: '企业近三年研发经费复合增长率（引用第14项）', unit: '%', type: 'calculated', formula: 'linked', sourceIndicator: 14, sourceField: 'rdExpenditureCagr' },
      { key: 'regionalAverageCagr', label: '所在地区规模以上企业平均增长率', unit: '%', type: 'number', allowNegative: true },
      { key: 'directedIncreaseRatio', label: '关键领域定向增投比', unit: '%', type: 'number' },
      { key: 'enterpriseRdIntensity', label: '企业研发投入强度', unit: '%', type: 'number' },
      { key: 'benchmarkRdIntensity', label: '行业标杆企业平均研发投入强度', unit: '%', type: 'number' },
      { key: 'description', label: '地区平均、关键领域或行业标杆对比依据说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ field: 'threeYearCagr', operator: '>=', compareField: 'regionalAverageCagr' }],
        ruleReviewRequired: true,
        note: '地区规模以上企业平均增长率的数据来源需要人工核验'
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'AND', conditions: [
          { field: 'threeYearCagr', operator: '>=', compareField: 'regionalAverageCagr' },
          { logic: 'OR', conditions: [
            { field: 'directedIncreaseRatio', operator: '>', value: 50 },
            { field: 'enterpriseRdIntensity', operator: '>', compareField: 'benchmarkRdIntensity' }
          ] }
        ] }],
        ruleReviewRequired: true,
        note: '"关键领域"界定及行业标杆企业对比需要人工核验'
      }
    }
  },
  {
    id: 14,
    level1: '创新投入',
    level2: '研发投入',
    name: '近三年研发经费投入增长率',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '根据连续三年研发经费计算投入增长情况，并核验是否保持稳定增长',
    fields: [
      { key: 'rdExpenditureYear1', label: '第一年研发经费', unit: '万元', type: 'number' },
      { key: 'rdExpenditureYear2', label: '第二年研发经费', unit: '万元', type: 'number' },
      { key: 'rdExpenditureYear3', label: '第三年研发经费', unit: '万元', type: 'number' },
      { key: 'rdExpenditureCagr', label: '近三年复合增长率（按指南公式计算）', unit: '%', type: 'calculated', formula: 'cagr', fields: ['rdExpenditureYear1', 'rdExpenditureYear3'] },
      { key: 'description', label: '增长情况说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'AND', conditions: [
          { field: 'rdExpenditureYear2', operator: '>', compareField: 'rdExpenditureYear1' },
          { field: 'rdExpenditureYear3', operator: '>', compareField: 'rdExpenditureYear2' }
        ] }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'AND', conditions: [
          { field: 'rdExpenditureYear2', operator: '>', compareField: 'rdExpenditureYear1' },
          { field: 'rdExpenditureYear3', operator: '>', compareField: 'rdExpenditureYear2' }
        ] }]
      }
    }
  },
  {
    id: 15,
    level1: '创新投入',
    level2: '数字化水平',
    name: '企业数字化水平',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '根据工信部中小企业数字化水平评测指标确定的等级',
    fields: [
      { key: 'digitalLevel', label: '企业数字化水平等级（工信部评测）', type: 'select', placeholder: '请选择数字化水平等级', options: [
        { id: 1, label: '一级' },
        { id: 2, label: '二级' },
        { id: 3, label: '三级' },
        { id: 4, label: '四级' }
      ] }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        isCoreRequired: true,
        rules: [{ field: 'digitalLevel', operator: '>=', value: 3 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ field: 'digitalLevel', operator: '>=', value: 4 }]
      }
    }
  },
  {
    id: 16,
    level1: '创新投入',
    level2: '数字化水平',
    name: '数字化工具覆盖率',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '报告年度企业使用数字化方式实现数据处理的覆盖率',
    fields: [
      { key: 'digitalToolCoverage', label: '数字化工具覆盖率', unit: '%', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        rules: [{ field: 'digitalToolCoverage', operator: '>=', value: 80 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ field: 'digitalToolCoverage', operator: '>=', value: 80 }]
      }
    }
  },
  {
    id: 17,
    level1: '创新投入',
    level2: '数字化水平',
    name: '上一年度企业数字资产增长率',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '企业核心数字资产本年度评估价值与上一年度评估价值的增长情况',
    fields: [
      { key: 'previousDigitalAssetValue', label: '上一年度核心数字资产价值', unit: '万元', type: 'number', min: 0.01 },
      { key: 'currentDigitalAssetValue', label: '本年度核心数字资产价值', unit: '万元', type: 'number' },
      { key: 'digitalAssetGrowthRate', label: '上一年度企业数字资产增长率（系统计算）', unit: '%', type: 'calculated', formula: 'growthRate', fields: ['previousDigitalAssetValue', 'currentDigitalAssetValue'] },
      { key: 'description', label: '数字资产范围、估值口径及变化情况说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        ruleReviewRequired: true,
        note: '指南未给出明确增长率阈值，需由审核人员结合价值增长率和估值材料核验'
      }
    }
  },
  {
    id: 18,
    level1: '创新突破',
    level2: '产业生态',
    name: '近三年企业与上下游企业的合作数量',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '近三年企业与上下游企业的合作数量',
    fields: [
      { key: 'supplyChainPartners', label: '上下游企业合作项目或协议数量', unit: '项', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        rules: [{ field: 'supplyChainPartners', operator: '>=', value: 3 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [{ field: 'supplyChainPartners', operator: '>=', value: 5 }]
      }
    }
  },
  {
    id: 19,
    level1: '创新突破',
    level2: '产业生态',
    name: '产业链主导力',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '衡量企业在人工智能产业链中的核心影响力',
    fields: [
      { key: 'activeContributors', label: '主导开源项目或社区活跃贡献者数量', unit: '人', type: 'number' },
      { key: 'globalStars', label: '主导开源项目全球Star数量', unit: '个', type: 'number' },
      { key: 'ledMajorCollaborationProjects', label: '近三年主导完成产业链级重大协同创新项目数量', unit: '项', type: 'number' },
      { key: 'description', label: '生态构建、项目成果及参与者情况说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'required',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'OR', conditions: [
          { field: 'activeContributors', operator: '>=', value: 1000 },
          { field: 'globalStars', operator: '>=', value: 10000 },
          { field: 'ledMajorCollaborationProjects', operator: '>=', value: 1 }
        ] }],
        ruleReviewRequired: true,
        note: '"活跃贡献者≥1000人"的统计口径需要人工核验'
      }
    }
  },
  {
    id: 20,
    level1: '创新突破',
    level2: '协同',
    name: '产业链协同创新项目数',
    type: INDICATOR_TYPES.NUMBER,
    evaluationMode: EVALUATION_MODES.AUTOMATIC,
    description: '近三年企业参与或主导的协同创新项目数量',
    fields: [
      { key: 'collaborativeProjects', label: '产业链协同创新项目数', unit: '项', type: 'number' },
      { key: 'breakthroughProjects', label: '产生颠覆性技术突破的项目数', unit: '项', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'required',
        rules: [{ field: 'collaborativeProjects', operator: '>=', value: 2 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'required',
        rules: [
          {
            logic: 'AND',
            conditions: [
              { field: 'collaborativeProjects', operator: '>=', value: 5 },
              { field: 'breakthroughProjects', operator: '>=', value: 2 }
            ]
          }
        ]
      }
    }
  },
  {
    id: 21,
    level1: '创新特色',
    level2: '核心算法与模型能力',
    name: '开源榜单上榜情况',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '企业主导或核心维护的开源项目是否进入权威技术榜单',
    isSpecial: true,
    fields: [
      { key: 'recentAuthoritativeRanking', label: '近一年是否进入全球公认的权威技术榜单', type: 'radio', options: ['是', '否'] },
      { key: 'multipleRankings', label: '近一年是否持续上榜2次及以上', type: 'radio', options: ['是', '否'] },
      { key: 'topEndorsement', label: '项目是否获得国际顶级科技公司官方推荐或采纳', type: 'radio', options: ['是', '否'] },
      { key: 'contributorCommitteeMentor', label: '核心贡献者是否获国际顶级基金会正式邀请担任委员会成员或导师', type: 'radio', options: ['是', '否'] },
      { key: 'description', label: '榜单、项目链接及背书情况说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'optional_special',
        rules: [{ field: 'recentAuthoritativeRanking', operator: '==', value: '是' }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'optional_special',
        rules: [{ logic: 'OR', conditions: [
          { logic: 'AND', conditions: [
            { field: 'recentAuthoritativeRanking', operator: '==', value: '是' },
            { field: 'multipleRankings', operator: '==', value: '是' }
          ] },
          { field: 'topEndorsement', operator: '==', value: '是' },
          { field: 'contributorCommitteeMentor', operator: '==', value: '是' }
        ] }]
      }
    }
  },
  {
    id: 22,
    level1: '创新特色',
    level2: '核心算法与模型能力',
    name: '核心算法/模型备案情况',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '国家网信办备案数量',
    isSpecial: true,
    fields: [
      { key: 'modelFilingCount', label: '国家网信办核心算法/模型备案数量', unit: '项', type: 'number' },
      { key: 'hasGenerativeFiling', label: '是否至少包含1项生成式人工智能备案', type: 'radio', options: ['是', '否'] },
      { key: 'hasFilingMatrix', label: '是否已形成体系化备案矩阵', type: 'radio', options: ['是', '否'] },
      { key: 'isIndustryExample', label: '备案实践是否已成为行业范例', type: 'radio', options: ['是', '否'] }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'core_special',
        rules: [{ field: 'modelFilingCount', operator: '>=', value: 1 }]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'core_special',
        rules: [{ logic: 'OR', conditions: [
          { field: 'modelFilingCount', operator: '>=', value: 2 },
          { field: 'hasGenerativeFiling', operator: '==', value: '是' }
        ] }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'core_special',
        rules: [{ logic: 'AND', conditions: [
          { field: 'modelFilingCount', operator: '>=', value: 3 },
          { field: 'hasFilingMatrix', operator: '==', value: '是' },
          { field: 'isIndustryExample', operator: '==', value: '是' }
        ] }]
      }
    }
  },
  {
    id: 23,
    level1: '创新特色',
    level2: '核心算法与模型能力',
    name: '大模型/专用模型技术落地场景数',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '已验证并产生价值的行业应用案例数量',
    isSpecial: true,
    fields: [
      { key: 'modelScenes', label: '大模型/专用模型技术落地场景数', unit: '个', type: 'number' },
      { key: 'benchmarkCases', label: '行业公认标杆案例数', unit: '个', type: 'number' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'core_special',
        rules: [{ field: 'modelScenes', operator: '>=', value: 1 }]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'core_special',
        rules: [{ field: 'modelScenes', operator: '>=', value: 1 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'core_special',
        rules: [{ logic: 'AND', conditions: [
          { field: 'modelScenes', operator: '>=', value: 2 },
          { field: 'benchmarkCases', operator: '>=', value: 1 }
        ] }]
      }
    }
  },
  {
    id: 24,
    level1: '创新特色',
    level2: '数据资产与算力基础',
    name: '数据资产化管理与安全水平',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '企业将数据作为核心资产进行管理和保护的系统化能力',
    isSpecial: true,
    fields: [
      { key: 'hasDataGovernanceFramework', label: '是否已建立数据治理与安全管理体系', type: 'radio', options: ['是', '否'] },
      { key: 'dataManagementMaturityLevel', label: '数据管理能力成熟度认证情况', type: 'select', placeholder: '请选择认证情况', options: [
        { id: 0, label: '未认证' },
        { id: 1, label: 'DCMM 一级' },
        { id: 2, label: 'DCMM 二级' },
        { id: 3, label: 'DCMM 三级' },
        { id: 4, label: 'DCMM 四级' },
        { id: 5, label: 'DCMM 五级' },
        { id: 99, label: '同等能力认证（需人工核验）' }
      ] },
      { key: 'hasDataAssetOperation', label: '是否已开展数据资产化运营或价值实现', type: 'radio', options: ['是', '否'] },
      { key: 'description', label: '数据治理、认证及资产化运营情况说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'core_special',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ field: 'hasDataGovernanceFramework', operator: '==', value: '是' }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'core_special',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'AND', conditions: [
          { logic: 'OR', conditions: [
            { field: 'dataManagementMaturityLevel', operator: '>=', value: 3 },
            { field: 'dataManagementMaturityLevel', operator: '==', value: 99 }
          ] },
          { field: 'hasDataAssetOperation', operator: '==', value: '是' }
        ] }],
        ruleReviewRequired: true,
        note: '同等能力认证及数据资产化运营成效需要人工核验'
      }
    }
  },
  {
    id: 25,
    level1: '创新特色',
    level2: '数据资产与算力基础',
    name: '算力资源投入强度',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '为支持AI研发与业务运行的底层计算资源投入',
    isSpecial: true,
    fields: [
      { key: 'computingExpenditure', label: '算力支出', unit: '万元', type: 'number' },
      { key: 'ownComputingPower', label: '自有算力', unit: 'PFLOPS', type: 'number' },
      { key: 'description', label: '算力投入及行业对标情况说明（由审核人员核验）', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'core_special',
        rules: [
          {
            logic: 'OR',
            conditions: [
              { field: 'computingExpenditure', operator: '>=', value: 200 },
              { field: 'ownComputingPower', operator: '>=', value: 1 }
            ]
          }
        ]
      },
      [LEVELS.LEADING]: {
        requiredType: 'core_special',
        evaluationMode: EVALUATION_MODES.HYBRID,
        ruleReviewRequired: true,
        note: '"行业前十"的判定需要人工核验'
      }
    }
  },
  {
    id: 26,
    level1: '创新特色',
    level2: '智能硬件与装备创新',
    name: '智能装备/解决方案累计规模化部署量',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '智能硬件产品或解决方案的市场验证与规模化能力',
    isSpecial: true,
    fields: [
      { key: 'equipmentDeployment', label: '智能装备/解决方案累计规模化部署量', unit: '套', type: 'number' },
      { key: 'nationalTopThree', label: '细分市场占有率是否位居全国前三', type: 'radio', options: ['是', '否'] }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: {
        requiredType: 'core_special',
        rules: [{ field: 'equipmentDeployment', operator: '>=', value: 20 }]
      },
      [LEVELS.STANDARD]: {
        requiredType: 'optional_special',
        rules: [{ field: 'equipmentDeployment', operator: '>=', value: 100 }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'optional_special',
        rules: [
          {
            logic: 'OR',
            conditions: [
              { field: 'equipmentDeployment', operator: '>=', value: 800 },
              { field: 'nationalTopThree', operator: '==', value: '是' }
            ]
          }
        ],
        ruleReviewRequired: true,
        note: '市场占有率全国前三需要人工核验'
      }
    }
  },
  {
    id: 27,
    level1: '创新特色',
    level2: '智能硬件与装备创新',
    name: '自主可控与供应链安全能力',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '综合评价企业在硬件供应链与软件/系统供应链两方面的自主可控与安全能力',
    isSpecial: true,
    fields: [
      { key: 'hardwareLocalizationRate', label: '核心硬件元器件国产化率', unit: '%', type: 'number' },
      { key: 'softwareSecurityLevel', label: '主营软件/系统供应链安全认证等级', type: 'select', options: [
        { id: 0, label: '未认证' },
        { id: 1, label: '一级认证' },
        { id: 2, label: '二级认证' },
        { id: 3, label: '三级认证' }
      ] },
      { key: 'hasSelfDevelopedMassProduction', label: '是否至少有1项自研核心元器件实现量产', type: 'radio', options: ['是', '否'] }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'optional_special',
        rules: [{ logic: 'OR', conditions: [
          { field: 'hardwareLocalizationRate', operator: '>=', value: 50 },
          { field: 'softwareSecurityLevel', operator: '>=', value: 1 }
        ] }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'optional_special',
        rules: [{ logic: 'OR', conditions: [
          { logic: 'AND', conditions: [
            { field: 'hardwareLocalizationRate', operator: '>=', value: 80 },
            { field: 'hasSelfDevelopedMassProduction', operator: '==', value: '是' }
          ] },
          { field: 'softwareSecurityLevel', operator: '>=', value: 2 },
          { logic: 'AND', conditions: [
            { field: 'hardwareLocalizationRate', operator: '>=', value: 50 },
            { field: 'softwareSecurityLevel', operator: '>=', value: 1 }
          ] }
        ] }]
      }
    }
  },
  {
    id: 28,
    level1: '创新特色',
    level2: '产业融合与价值实现',
    name: '跨行业场景融合效能',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: 'AI技术对垂直行业核心业务流程产生的实质性深度优化与模式变革能力',
    isSpecial: true,
    fields: [
      { key: 'deepFusionCaseCount', label: '达到所填优化幅度的深度融合案例数量', unit: '个', type: 'number' },
      { key: 'optimizationRate', label: '客户核心业务指标优化幅度', unit: '%', type: 'number' },
      { key: 'hasRevolutionaryInnovation', label: '是否实现跨行业场景首次应用的革命性模式创新', type: 'radio', options: ['是', '否'] },
      { key: 'description', label: '深度融合案例、客户指标及模式创新说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: {
        requiredType: 'optional_special',
        rules: [{ logic: 'AND', conditions: [
          { field: 'deepFusionCaseCount', operator: '>=', value: 1 },
          { field: 'optimizationRate', operator: '>=', value: 20 }
        ] }]
      },
      [LEVELS.LEADING]: {
        requiredType: 'optional_special',
        rules: [{ logic: 'OR', conditions: [
          { logic: 'AND', conditions: [
            { field: 'deepFusionCaseCount', operator: '>=', value: 1 },
            { field: 'optimizationRate', operator: '>=', value: 30 }
          ] },
          { field: 'hasRevolutionaryInnovation', operator: '==', value: '是' }
        ] }]
      }
    }
  },
  {
    id: 29,
    level1: '创新特色',
    level2: '企业内生智能化水平',
    name: '企业内部运营AI原生化程度',
    type: INDICATOR_TYPES.COMPLEX,
    evaluationMode: EVALUATION_MODES.HYBRID,
    description: '企业利用AI提升自身运营效率的水平',
    isSpecial: true,
    fields: [
      { key: 'aiAppliedProcesses', label: 'AI已深度应用的企业核心流程', type: 'checkbox', options: [
        { id: 'rd', label: '研发' },
        { id: 'production', label: '生产' },
        { id: 'marketing', label: '营销' },
        { id: 'management', label: '管理' },
        { id: 'other', label: '其他核心流程' },
        { id: 'none', label: '暂无' }
      ] },
      { key: 'efficiencyCaseCount', label: '显著提效案例数量', unit: '个', type: 'number' },
      { key: 'hasExportableMethodology', label: '是否形成可对外输出的方法论', type: 'radio', options: ['是', '否'] },
      { key: 'description', label: 'AI应用流程、提效案例及方法论说明', type: 'textarea' }
    ],
    requirements: {
      [LEVELS.PREPARATORY]: null,
      [LEVELS.STANDARD]: null,
      [LEVELS.LEADING]: {
        requiredType: 'core_special',
        evaluationMode: EVALUATION_MODES.HYBRID,
        rules: [{ logic: 'AND', conditions: [
          { type: 'select_n', field: 'aiAppliedProcesses', n: 1, excludeId: 'none' },
          { field: 'efficiencyCaseCount', operator: '>=', value: 3 },
          { field: 'hasExportableMethodology', operator: '==', value: '是' }
        ] }],
        ruleReviewRequired: true,
        note: 'AI深度应用程度、提效显著性及方法论可输出性需人工核验'
      }
    }
  }
]

export default indicators
